import { render, staticRenderFns } from "./CredentialInputs.vue?vue&type=template&id=47a60c55"
import script from "./CredentialInputs.vue?vue&type=script&lang=ts"
export * from "./CredentialInputs.vue?vue&type=script&lang=ts"
import style0 from "./CredentialInputs.vue?vue&type=style&index=0&id=47a60c55&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports